import Vue from 'vue'
import {formatDate} from 'helpers/formatDate'
import floatToPercent from 'filters/floatToPercent.js'
import addCommas from 'filters/addCommas.js'
import toFixedPercent from 'filters/toFixedPercent.js'
Vue.filter('date', formatDate)
Vue.filter('floatToPercent', floatToPercent)
Vue.filter('toFixedPercent', toFixedPercent)
Vue.filter('addCommas', addCommas)



// WEBPACK FOOTER //
// ./src/filters/index.js